import { render, staticRenderFns } from "./WebsiteOrderPay.vue?vue&type=template&id=3a2ec74a&"
import script from "./WebsiteOrderPay.vue?vue&type=script&lang=js&"
export * from "./WebsiteOrderPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports